import { AxiosResponse } from 'axios';
import { SET_SHIUREI_TORAH_TEMPLATES, SET_SHIUREI_TORAH_TEMPLATE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_SHIUREI_TORAH_TEMPLATE_ISLOADING,
  DELETE_SHIUREI_TORAH_TEMPLATE,
  EDIT_SHIUREI_TORAH_TEMPLATE,
  GET_SHIUREI_TORAH_TEMPLATES,
  REGISTER_SHIUREI_TORAH_TEMPLATE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ShiureiTorahTemplate from '@/services/shiurei_torah_template';
import { Module } from 'vuex';
import { EditShiureiTorahTemplate, RegisterShiureiTorahTemplate, GetShiureiTorahTemplate } from '@/dtos/shiurei_torah_template.dto';

const shiureiTorahTemplate: Module<any, {}> = {
  state: {
    shiureiTorahTemplate: {
      data: null,
      isLoading: false,
    },
    shiureiTorahTemplates: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    shiureiTorahTemplate: (state: { shiureiTorahTemplate: any }) => state.shiureiTorahTemplate,
    shiureiTorahTemplates: (state: { shiureiTorahTemplates: any }) => state.shiureiTorahTemplates,
  },
  mutations: {
    [SET_SHIUREI_TORAH_TEMPLATE]: (
      state: { shiureiTorahTemplate: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.shiureiTorahTemplate.data = payload.data) : null,
        (state.shiureiTorahTemplate.isLoading = payload.isLoading);
    },
    [SET_SHIUREI_TORAH_TEMPLATES]: (
      state: { shiureiTorahTemplates: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.shiureiTorahTemplates.data = payload.data) : null,
        (state.shiureiTorahTemplates.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_SHIUREI_TORAH_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await ShiureiTorahTemplate.registerShiureiTorahTemplate(
        payload as RegisterShiureiTorahTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_SHIUREI_TORAH_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SHIUREI_TORAH_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [GET_SHIUREI_TORAH_TEMPLATES]: async ({ commit }: any, payload: any) => {
      commit(SET_SHIUREI_TORAH_TEMPLATES, { data: null, isLoading: true });

      const result: AxiosResponse = await ShiureiTorahTemplate.getShiureiTorahTemplates(
        payload as GetShiureiTorahTemplate
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SHIUREI_TORAH_TEMPLATES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SHIUREI_TORAH_TEMPLATES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SHIUREI_TORAH_TEMPLATES, { isLoading: false });
        return false;
      }
    },
    [EDIT_SHIUREI_TORAH_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await ShiureiTorahTemplate.editShiureiTorahTemplate(
        payload as EditShiureiTorahTemplate
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SHIUREI_TORAH_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SHIUREI_TORAH_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [DELETE_SHIUREI_TORAH_TEMPLATE]: async ({ commit }: any, payload: string) => {
      commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await ShiureiTorahTemplate.deleteShiureiTorahTemplate(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_SHIUREI_TORAH_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_SHIUREI_TORAH_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_SHIUREI_TORAH_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_SHIUREI_TORAH_TEMPLATE_ISLOADING]: ({ commit }) => {
      commit(SET_SHIUREI_TORAH_TEMPLATE, { isLoading: false });
      commit(SET_SHIUREI_TORAH_TEMPLATES, { isLoading: false });
    },
  },
};

export default shiureiTorahTemplate;
